import React, { useState } from 'react';
import { Sidebar } from '../components/dashboard/Sidebar';
import { OverviewTab } from '../components/dashboard/OverviewTab';
import { QuotesTab } from '../components/dashboard/QuotesTab';
import { QuoteDetail } from '../components/dashboard/QuoteDetail';
import { HoldsTab } from '../components/dashboard/HoldsTab';
import { AnalyticsTab } from '../components/dashboard/AnalyticsTab';
// Mock Data
const MOCK_QUOTES = [{
  id: 'BQ-8492',
  agency: 'Liberty Travel',
  groupName: 'Smith-Johnson Wedding',
  property: 'Moon Palace Cancun',
  dates: 'Oct 12 - Oct 16, 2026',
  rooms: 45,
  status: 'Held',
  value: 125000,
  expiryHours: 14
}, {
  id: 'BQ-8491',
  agency: 'Flight Centre',
  groupName: 'TechCorp Annual Retreat',
  property: 'The Grand at Moon Palace',
  dates: 'Nov 05 - Nov 09, 2026',
  rooms: 120,
  status: 'Sent',
  value: 480000,
  expiryHours: null
}, {
  id: 'BQ-8490',
  agency: 'Direct',
  groupName: 'Williams Family Reunion',
  property: 'Moon Palace Jamaica',
  dates: 'Dec 20 - Dec 27, 2026',
  rooms: 15,
  status: 'Contracted',
  value: 85000,
  expiryHours: null
}, {
  id: 'BQ-8489',
  agency: 'Expedia Partner Solutions',
  groupName: 'Medical Conference 2026',
  property: 'Le Blanc Spa Resort Cancun',
  dates: 'Sep 10 - Sep 14, 2026',
  rooms: 80,
  status: 'Draft',
  value: 320000,
  expiryHours: null
}, {
  id: 'BQ-8488',
  agency: 'Travel Leaders',
  groupName: 'Yoga Wellness Retreat',
  property: 'Le Blanc Spa Resort Los Cabos',
  dates: 'Jan 15 - Jan 20, 2027',
  rooms: 25,
  status: 'Held',
  value: 145000,
  expiryHours: 42
}, {
  id: 'BQ-8487',
  agency: 'ProTravel',
  groupName: 'Goldman Incentive Trip',
  property: 'The Grand at Moon Palace',
  dates: 'Feb 01 - Feb 05, 2027',
  rooms: 200,
  status: 'Expired',
  value: 950000,
  expiryHours: 0
}];
type TabType = 'overview' | 'quotes' | 'holds' | 'analytics';
export function Dashboard() {
  const [activeTab, setActiveTab] = useState<TabType>('overview');
  const [selectedQuoteId, setSelectedQuoteId] = useState<string | null>(null);
  const handleNavigate = (tab: TabType) => {
    setActiveTab(tab);
    setSelectedQuoteId(null);
  };
  const handleSelectQuote = (id: string) => {
    setSelectedQuoteId(id);
  };
  const renderContent = () => {
    if (selectedQuoteId) {
      return <QuoteDetail quoteId={selectedQuoteId} onBack={() => setSelectedQuoteId(null)} quotes={MOCK_QUOTES} data-id="element-1268" />;
    }
    switch (activeTab) {
      case 'overview':
        return <OverviewTab onNavigate={handleNavigate} onSelectQuote={handleSelectQuote} quotes={MOCK_QUOTES} data-id="element-1269" />;
      case 'quotes':
        return <QuotesTab onSelectQuote={handleSelectQuote} quotes={MOCK_QUOTES} data-id="element-1270" />;
      case 'holds':
        return <HoldsTab onSelectQuote={handleSelectQuote} quotes={MOCK_QUOTES} data-id="element-1271" />;
      case 'analytics':
        return <AnalyticsTab data-id="element-1272" />;
      default:
        return <OverviewTab onNavigate={handleNavigate} onSelectQuote={handleSelectQuote} quotes={MOCK_QUOTES} data-id="element-1273" />;
    }
  };
  return <div className="flex h-screen bg-stone-50 font-sans text-stone-900 overflow-hidden selection:bg-red-600/20" data-id="element-1274">
      <Sidebar activeTab={activeTab} setActiveTab={handleNavigate} data-id="element-1275" />

      <main className="flex-1 overflow-y-auto" data-id="element-1276">
        <div className="max-w-7xl mx-auto p-8 md:p-12" data-id="element-1277">{renderContent()}</div>
      </main>
    </div>;
}